<mat-toolbar color="primary">
  @if (showMenuButton) {
    <button mat-icon-button (click)="onMenuClick()">
      <mat-icon>menu</mat-icon>
    </button>
  }
  <span class="circle-white"><img src="assets/logos/logo 150.png" alt="Green Village" class="toolbar-logo"></span>
  <span class="nunito-sans-title">GREEN VILLAGE</span>
  <span class="spacer"></span>
  @if (userName) {
    <button mat-button [matMenuTriggerFor]="userMenu" aria-label="Usuário">
      {{ (userName || '').split(' ')[0] }}
    </button>
    <button mat-icon-button [matMenuTriggerFor]="invitationMenu" aria-label="Convites">
      <mat-icon [matBadge]="invitations.length" [matBadgeHidden]="invitations.length === 0" matBadgeColor="accent">notifications</mat-icon>
    </button>
  }
</mat-toolbar>

<mat-menu #userMenu="matMenu">
  <button mat-menu-item [routerLink]="'/profile'">
    <mat-icon>person</mat-icon>
    <span>Perfil</span>
  </button>
  <button mat-menu-item (click)="onLogout()">
    <mat-icon>logout</mat-icon>
    <span>logout</span>
  </button>
</mat-menu>

<mat-menu #invitationMenu="matMenu">
  @if (invitations.length === 0) {
    <button mat-menu-item disabled>Nenhum convite</button>
  } @else {
    @for (invitation of invitations; track invitation.id) {
      <button mat-menu-item (click)="onInvitationClick(invitation)">
        Você foi convidado para {{ invitation.condominium.name }}
      </button>
    }
  }
</mat-menu>
